export const deadlines = [
  "November 1 2025 23:59:59 GMT+0400",
  "November 4 2025 23:59:59 GMT+0400",
  "November 7 2025 23:59:59 GMT+0400",
  "November 10 2025 23:59:59 GMT+0400",
  "November 13 2025 23:59:59 GMT+0400",
  "November 16 2025 23:59:59 GMT+0400",
  "November 19 2025 23:59:59 GMT+0400",
  "November 22 2025 23:59:59 GMT+0400",
  "November 25 2025 23:59:59 GMT+0400",
  "November 28 2025 23:59:59 GMT+0400",
  "December 1 2025 23:59:59 GMT+0400",
  "December 4 2025 23:59:59 GMT+0400",
  "December 7 2025 23:59:59 GMT+0400",
  "December 10 2025 23:59:59 GMT+0400",
  "December 13 2025 23:59:59 GMT+0400",
  "December 16 2025 23:59:59 GMT+0400",
  "December 19 2025 23:59:59 GMT+0400",
  "December 22 2025 23:59:59 GMT+0400",
  "December 25 2025 23:59:59 GMT+0400",
  "December 28 2025 23:59:59 GMT+0400",
  "December 31 2025 23:59:59 GMT+0400",
  "January 3 2026 23:59:59 GMT+0400",
  "January 6 2026 23:59:59 GMT+0400",
  "January 9 2026 23:59:59 GMT+0400",
  "January 12 2026 23:59:59 GMT+0400",
  "January 15 2026 23:59:59 GMT+0400",
  "January 18 2026 23:59:59 GMT+0400",
  "January 21 2026 23:59:59 GMT+0400",
  "January 24 2026 23:59:59 GMT+0400",
  "January 27 2026 23:59:59 GMT+0400",
  "January 30 2026 23:59:59 GMT+0400",
  "February 2 2026 23:59:59 GMT+0400",
  "February 5 2026 23:59:59 GMT+0400",
  "February 8 2026 23:59:59 GMT+0400",
  "February 11 2026 23:59:59 GMT+0400",
  "February 14 2026 23:59:59 GMT+0400",
  "February 17 2026 23:59:59 GMT+0400",
  "February 20 2026 23:59:59 GMT+0400",
  "February 23 2026 23:59:59 GMT+0400",
  "February 26 2026 23:59:59 GMT+0400",
  "March 1 2026 23:59:59 GMT+0400",
  "March 4 2026 23:59:59 GMT+0400",
  "March 7 2026 23:59:59 GMT+0400",
  "March 10 2026 23:59:59 GMT+0400",
  "March 13 2026 23:59:59 GMT+0400",
  "March 16 2026 23:59:59 GMT+0400",
  "March 19 2026 23:59:59 GMT+0400",
  "March 22 2026 23:59:59 GMT+0400",
  "March 25 2026 23:59:59 GMT+0400",
  "March 28 2026 23:59:59 GMT+0400",
  "March 31 2026 23:59:59 GMT+0400",
  "April 3 2026 23:59:59 GMT+0400",
  "April 6 2026 23:59:59 GMT+0400",
  "April 9 2026 23:59:59 GMT+0400",
  "April 12 2026 23:59:59 GMT+0400",
  "April 15 2026 23:59:59 GMT+0400",
  "April 18 2026 23:59:59 GMT+0400",
  "April 21 2026 23:59:59 GMT+0400",
  "April 24 2026 23:59:59 GMT+0400",
  "April 27 2026 23:59:59 GMT+0400",
  "April 30 2026 23:59:59 GMT+0400",
  "May 3 2026 23:59:59 GMT+0400",
  "May 6 2026 23:59:59 GMT+0400",
  "May 9 2026 23:59:59 GMT+0400",
  "May 12 2026 23:59:59 GMT+0400",
  "May 15 2026 23:59:59 GMT+0400",
  "May 18 2026 23:59:59 GMT+0400",
  "May 21 2026 23:59:59 GMT+0400",
  "May 24 2026 23:59:59 GMT+0400",
  "May 27 2026 23:59:59 GMT+0400",
  "May 30 2026 23:59:59 GMT+0400",
  "June 2 2026 23:59:59 GMT+0400",
  "June 5 2026 23:59:59 GMT+0400",
  "June 8 2026 23:59:59 GMT+0400",
  "June 11 2026 23:59:59 GMT+0400",
  "June 14 2026 23:59:59 GMT+0400",
  "June 17 2026 23:59:59 GMT+0400",
  "June 20 2026 23:59:59 GMT+0400",
  "June 23 2026 23:59:59 GMT+0400",
  "June 26 2026 23:59:59 GMT+0400",
  "June 29 2026 23:59:59 GMT+0400",
  "July 2 2026 23:59:59 GMT+0400",
  "July 5 2026 23:59:59 GMT+0400",
  "July 8 2026 23:59:59 GMT+0400",
  "July 11 2026 23:59:59 GMT+0400",
  "July 14 2026 23:59:59 GMT+0400",
  "July 17 2026 23:59:59 GMT+0400",
  "July 20 2026 23:59:59 GMT+0400",
  "July 23 2026 23:59:59 GMT+0400",
  "July 26 2026 23:59:59 GMT+0400",
  "July 29 2026 23:59:59 GMT+0400",
  "August 1 2026 23:59:59 GMT+0400",
  "August 4 2026 23:59:59 GMT+0400",
  "August 7 2026 23:59:59 GMT+0400",
  "August 10 2026 23:59:59 GMT+0400",
  "August 13 2026 23:59:59 GMT+0400",
  "August 16 2026 23:59:59 GMT+0400",
  "August 19 2026 23:59:59 GMT+0400",
  "August 22 2026 23:59:59 GMT+0400",
  "August 25 2026 23:59:59 GMT+0400",
  "August 28 2026 23:59:59 GMT+0400",
  "August 31 2026 23:59:59 GMT+0400",
  "September 3 2026 23:59:59 GMT+0400",
  "September 6 2026 23:59:59 GMT+0400",
  "September 9 2026 23:59:59 GMT+0400",
  "September 12 2026 23:59:59 GMT+0400",
  "September 15 2026 23:59:59 GMT+0400",
  "September 18 2026 23:59:59 GMT+0400",
  "September 21 2026 23:59:59 GMT+0400",
  "September 24 2026 23:59:59 GMT+0400",
  "September 27 2026 23:59:59 GMT+0400",
  "September 30 2026 23:59:59 GMT+0400",
  "October 3 2026 23:59:59 GMT+0400",
  "October 6 2026 23:59:59 GMT+0400",
  "October 9 2026 23:59:59 GMT+0400",
  "October 12 2026 23:59:59 GMT+0400",
  "October 15 2026 23:59:59 GMT+0400",
  "October 18 2026 23:59:59 GMT+0400",
  "October 21 2026 23:59:59 GMT+0400",
  "October 24 2026 23:59:59 GMT+0400",
  "October 27 2026 23:59:59 GMT+0400",
  "October 30 2026 23:59:59 GMT+0400",
  "November 2 2026 23:59:59 GMT+0400",
  "November 5 2026 23:59:59 GMT+0400",
  "November 8 2026 23:59:59 GMT+0400",
  "November 11 2026 23:59:59 GMT+0400",
  "November 14 2026 23:59:59 GMT+0400",
  "November 17 2026 23:59:59 GMT+0400",
  "November 20 2026 23:59:59 GMT+0400",
  "November 23 2026 23:59:59 GMT+0400",
  "November 26 2026 23:59:59 GMT+0400",
  "November 29 2026 23:59:59 GMT+0400",
  "December 2 2026 23:59:59 GMT+0400",
  "December 5 2026 23:59:59 GMT+0400",
  "December 8 2026 23:59:59 GMT+0400",
  "December 11 2026 23:59:59 GMT+0400",
  "December 14 2026 23:59:59 GMT+0400",
  "December 17 2026 23:59:59 GMT+0400",
  "December 20 2026 23:59:59 GMT+0400",
  "December 23 2026 23:59:59 GMT+0400",
  "December 26 2026 23:59:59 GMT+0400",
  "December 29 2026 23:59:59 GMT+0400",
  "December 31 2026 23:59:59 GMT+0400"
];
